import { render } from "./CampaignsDetailInformation.vue?vue&type=template&id=4cc43d5d&scoped=true"
import script from "./CampaignsDetailInformation.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailInformation.vue?vue&type=script&lang=js"

import "./CampaignsDetailInformation.vue?vue&type=style&index=0&id=4cc43d5d&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc43d5d"]])

export default __exports__